module.exports = "/_next/static/images/StayingAheadOfTheCurve-xs-474a33185d75fe861045d52090d8030c.webp";